$(document).ready(function() {

  $('.modal-slider-section .portfolio-header .item').on('click', function() {
    var clicked = $(this);
    $('.modal-slider-overlay').addClass('show');
    $('.modal-slider .slick-slide').removeClass('slick-active slick-current forward');
	$('.modal-slider .slick-slide').eq(clicked.index()).addClass('slick-active slick-current forward');
    console.log(clicked.index());
  });
  
  
  $('.modal-slider-section .modal-slider-overlay .slider-close').on('click', function() {
    $('.modal-slider-overlay').removeClass('show');
  });


});


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}